export default __webpack_public_path__ + "static/media/logo-yugioh.c106418b.png";